/**
 * Card Brand Enum
 */
export enum CardBrandEnum {
  "VISA" = "visa",
  "MASTERCARD" = "masterCard",
  "DINERS" = "diners",
  "ALIA" = "alia",
  "CARNET" = "carnet",
  "AMEX" = "amex",
}



// WEBPACK FOOTER //
// ./src/containers/Card/store/CardBrandEnum.ts